import type { SharedTypes } from '@semios/app-platform-banyan-route-definitions'
import { LabelWithExternalVendorIcons } from 'components/LabelWithExternalVendorIcons/LabelWithExternalVendorIcons'
import type { IMultiSelectProps, TOptions } from 'components/MultiSelect/MultiSelect.types'

export type TOptionsWithExternalVendors = TOptions & {
  externalVendorNames?: SharedTypes.IrrigationScheduler.EIrrigationVendorName[]
}

const ICON_SIZE = 16

export const makeExternalVendorMultiSelectProps = ({
  data,
}: {
  data: TOptionsWithExternalVendors[]
}): Pick<IMultiSelectProps<TOptions>, 'optionValueDecorator'> => {
  if (!data.some((option) => option.externalVendorNames?.length)) return {}

  const externalVendorNamesByValue = new Map(data.map((option) => [option.value, option.externalVendorNames]))

  return {
    optionValueDecorator: (label, option) => (
      <LabelWithExternalVendorIcons
        label={label}
        externalVendorNames={option && externalVendorNamesByValue.get(option.value)}
        iconSize={ICON_SIZE}
      />
    ),
  }
}
